import React from 'react';
import cx from 'classnames';

import Tooltip from '../../../components/Tooltip';

import { helpIcon, helpText, helpTextWrapper } from '../styles.module.css';

const Help = ({ children, className }) => {
  return (
    <div className={cx(helpIcon, className)}>
      <div className={helpTextWrapper}>
        <Tooltip className={helpText} position={Tooltip.position.LEFT}>
          {children}
        </Tooltip>
      </div>
      <span>?</span>
    </div>
  );
};

export default Help;
